import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LoginForm from './LoginForm';

const AuthGuard = ({ children }) => {
  const { user, loading, isAdmin, userRole } = useAuth();

  // Still loading auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // User is authenticated but role hasn't resolved yet — wait, don't kick to login
  if (user && !userRole && !isAdmin()) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying access...</p>
        </div>
      </div>
    );
  }

  const hasAccess = user && (isAdmin() || userRole === 'master_admin' || userRole === 'dealer_admin' || userRole === 'dealer_staff');

  if (!hasAccess) {
    return <LoginForm />;
  }

  return children;
};

export default AuthGuard;